import { render, staticRenderFns } from "./Asset3DInput.vue?vue&type=template&id=8ca8d100&scoped=true"
import script from "./Asset3DInput.vue?vue&type=script&lang=ts"
export * from "./Asset3DInput.vue?vue&type=script&lang=ts"
import style0 from "./Asset3DInput.vue?vue&type=style&index=0&id=8ca8d100&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca8d100",
  null
  
)

export default component.exports